module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#automobile",
      toString: function () {
        return this.url;
      }
    }